/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

"use strict";

var Model = require("../types/Model.js");
var mapObject = require("map-object");
var par = require("par");

/**
 * This model aggregates missed calls and missed messages into one place
 * The data is a map of ids to objects containging the count for missed `messages` and `calls`
 * @type {Model}
 */
module.exports = new Model({
	name: "missed",
	_messages: undefined,
	_voiceCalls: undefined,
	_calls: undefined,
	listeners: listeners,
	init: init,
	uninit: uninit,
	merge_values: merge_values
});

/**
 * Clears private variables for Garbage Collection
 */
function uninit() {
	this._messages = undefined;
	this._voiceCalls = undefined;
	this._calls = undefined;
	this._basicmessages = undefined;
}

/**
 * Sets up empty objects for `_messages` and `_calls`. Pushes empty object as initial state
 */
function init() {
	this._basicmessages = {};
	this._messages = {};
	this._voiceCalls = {};
	this._calls = {};

	this.push({
		count: {}
	});
}

/**
 * Sets up listeners for updates in missedcalls and missedmessages
 * @return {Object} A map of event names to event listeners
 */
function listeners() {
	return {
		"missedcalls:updated": handle_missed_calls_update,
		"missedvoicecalls:updated": handle_missed_voice_calls_update,
		"missedmessages:updated": handle_missed_messages_update,
		"basicmissedmessages:updated": handle_basic_missed_messages_update,
	};
}

/**
 * Merges the current values for messages and calls together.
 * Pushes new state
 */
function merge_values() {
	var messages = this._messages;
	var voiceCalls = this._voiceCalls;
	var calls = this._calls;
	var basicmessages = this._basicmessages;

	// Create result object
	var result = {};

	// Merge in call data
	mapObject.kv(calls, par(merge_as, result, "calls"));

	//Murge in voice call data
	mapObject.kv(voiceCalls, par(merge_as, result, "voiceCalls"));

	// Merge in message data
	mapObject.kv(messages, par(merge_as, result, "messages"));

	mapObject.kv(basicmessages, par(merge_as, result, "basicmessages"));

	var number_of_messages = Object.keys(messages).length;
	var number_of_voice_calls = Object.keys(voiceCalls).length;
	var number_of_calls = Object.keys(calls).length;
	var number_of_basic = Object.keys(basicmessages).length;

	var total_number_of_messages = Object.keys(messages).reduce(function(total, id){
		return total += messages[id];
	}, 0);

	result = setTotals(result);

	result.count = {
		totalmessages: total_number_of_messages,
		basic: number_of_basic,
		messages: number_of_messages,
		voiceCalls: number_of_voice_calls,
		calls: number_of_calls,
		all: number_of_calls + number_of_messages + number_of_voice_calls
	};

	this.push(result);
}

function merge_as(aggregator, property, id, value) {
	// Create new object for value at key if it doesn't exist
	var to_merge = aggregator[id] || (aggregator[id] = {});

	// Set the property at that id to a certain value
	to_merge[property] = value;
}

/**
 * Saves new version of MissedCall and merges with values of MissedMessages
 * @param  {Object} calls Map of ids to number of missed calls
 */
function handle_missed_calls_update(calls) {
	this._calls = calls;
	this.merge_values();
}

/**
 * Saves new version of missedVoiceCall and merges with other values
 * @param voiceCalls
 */
function handle_missed_voice_calls_update(voiceCalls){
	this._voiceCalls = voiceCalls;
	this.merge_values();
}


/**
 * Saves new version of MissedMessages and merges with values of MissedCall
 * @param  {Object} messages Map of ids to number of missed messages
 */
function handle_missed_messages_update(messages) {
	this._messages = messages;
	this.merge_values();
}

function handle_basic_missed_messages_update(messages){
	this._basicmessages = messages;
	this.merge_values();
}

function setTotals(object){
	return Object.keys(object).reduce(function(acc, key){
		var values = object[key];
		var all = calculateTotal(values);
		var atouchaway = calculateTotal(values, "messages");

		acc[key] = object[key];
		acc[key].all = all;
		acc[key].atouchaway = atouchaway;
		return acc;
	}, {});
}

function calculateTotal(values){
	var exclude = objToArr(arguments).slice(1);
	return Object.keys(values).reduce(function(total, key){
		if(exclude.indexOf(key) !== -1) return total;
		return total + values[key];
	}, 0);
}

function objToArr(obj){
	return Object.keys(obj).map(function(key){
		return obj[key];
	});
}